import Vue from 'vue';
import Chance from 'chance';
import { cloneDeep } from 'lodash';

import walkNodes from './walkNodes';

function setCustomMenuPayload(payload, caseConf) {
  const { customMenus } = caseConf;

  // Custom menus
  payload.customMenus = {};
  walkNodes(payload, ['CUSTOM_MENU'], (nodeData) => {
    let payloadGrandParent = payload.customMenus[nodeData.id];
    const sourceMenu = customMenus.find(menu => menu.category === nodeData.id);
    const sourceMenuItem = sourceMenu.items.find(item => item.id === nodeData.parentId);
    if (!payloadGrandParent) {
      payloadGrandParent = cloneDeep(sourceMenu);
      payloadGrandParent.items = [];
      payload.customMenus[nodeData.id] = payloadGrandParent;
    }
    let payloadParent = payloadGrandParent.items.find(item => item.content.en === sourceMenuItem.content.en);
    if (!payloadParent) {
      payloadParent = cloneDeep(sourceMenuItem);
      payloadParent.children = [];
      payloadGrandParent.items.push(payloadParent);
    }
    if (nodeData.childId) {
      const sourceMenuChild = sourceMenuItem.children.find(child => child.id === nodeData.childId);
      let payloadChild = payloadParent.children.find(child => child.content.en === sourceMenuChild.content.en);
      if (!payloadChild) {
        payloadChild = cloneDeep(sourceMenuChild);
        payloadParent.children.push(payloadChild);
      }
    }
  });
}

function pasteCustomMenus(caseConf, payload) {
  let areUpdates = false;

  // Copy custom menus
  if (payload.customMenus && Object.keys(payload.customMenus).length > 0) {
    if (!caseConf.customMenus) {
      Vue.set(caseConf, 'customMenus', []);
    }
    const customMenuMap = appendCustomMenu(caseConf.customMenus, payload.customMenus);

    walkNodes(payload, ['CUSTOM_MENU'], (nodeData) => {
      nodeData.id = customMenuMap[nodeData.id];
      nodeData.parentId = customMenuMap[nodeData.parentId];
      nodeData.childId = customMenuMap[nodeData.childId];
    });
    areUpdates = true;
  }

  return areUpdates;
}

function appendCustomMenu(destList, srcList) {
  const customMenuMap = {}; // { oldId: newId }
  const chance = new Chance();

  for (const sourceItem of Object.values(srcList)) {
    let destItem = (destList || []).find(
      caseItem => {
        return sourceItem.category === caseItem.category;
      }
    );
    if (!destItem) {
      destItem = {
        category: sourceItem.category,
        iconKey: sourceItem.iconKey,
        buttonLabel: sourceItem.buttonLabel,
        items: [],
      }
      destList.push(destItem);
    }
    customMenuMap[sourceItem.category] = destItem.category;
    for (const sourceParent of sourceItem.items) {
      let destParent = (destItem.items || []).find(
        caseParent => {
          return isContentEqual(sourceParent.content, caseParent.content);
        }
      );
      if (!destParent) {
        destParent = {
          id: chance.guid(),
          content: sourceParent.content,
          children: [],
          options: sourceParent.options,
        };
        destItem.items.push(destParent);
      }
      customMenuMap[sourceParent.id] = destParent.id;

      for (const sourceChild of sourceParent.children) {
        let destChild = (destParent.children || []).find(
          caseChild => {
            return isContentEqual(sourceChild.content, caseChild.content) &&
              sourceChild.options.enabled === caseChild.options.enabled;
          }
        );
        if (!destChild) {
          destChild = {
            id: chance.guid(),
            content: sourceChild.content,
            options: sourceChild.options,
          };
          destParent.children.push(destChild);
        }
        customMenuMap[sourceChild.id] = destChild.id;
      }
    }
  }

  // Update case position
  for (let i = 0; i < destList.length; i++) {
    for (let j = 0; j < destList[i].items.length; j++) {
      destList[i].items[j].options.position = j;
      for (let k = 0; k < destList[i].items[j].children.length; k++) {
        destList[i].items[j].children[k].options.position = k;
      }
    }
  }

  return customMenuMap;
}


function isContentEqual(content1, content2) {
  if (!content1 && !content2) {
    return true; // if field doesn't exist, treat it as true
  }
  // Compare two translated strings
  for (const [key, value] of Object.entries(content1)) {
    if (value !== content2[key]) {
      return false;
    }
  }
  return true;
}

export {
  setCustomMenuPayload,
  pasteCustomMenus,
};
